export default __webpack_public_path__ + "static/media/13.9471ee9b.png";